import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidaCompleta from "../pages/articoli/itaobuy-spreadsheet-guida-completa/page";
import Sicurezza from "../pages/articoli/itaobuy-spreadsheet-sicuro/page";
import Sneakers from "../pages/articoli/migliori-sneakers-itaobuy-spreadsheet/page";
import Principianti from "../pages/articoli/itaobuy-spreadsheet-principianti/page";
import CategoriePage from "../pages/articoli/categorie-itaobuy-spreadsheet/page";
import Recensione from "../pages/articoli/recensione-itaobuy-spreadsheet/page";
import Alternative from "../pages/articoli/itaobuy-spreadsheet-alternative/page";
import Qualita from "../pages/articoli/qualita-prodotti-itaobuy/page";
import ModaUomo from "../pages/articoli/itaobuy-spreadsheet-moda-uomo/page";
import ModaDonna from "../pages/articoli/itaobuy-spreadsheet-moda-donna/page";
import GuidaShopping from "../pages/articoli/itaobuy-spreadsheet-guida-shopping/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-guida-completa",
    element: <GuidaCompleta />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-sicuro",
    element: <Sicurezza />,
  },
  {
    path: "/articoli/migliori-sneakers-itaobuy-spreadsheet",
    element: <Sneakers />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-principianti",
    element: <Principianti />,
  },
  {
    path: "/articoli/categorie-itaobuy-spreadsheet",
    element: <CategoriePage />,
  },
  {
    path: "/articoli/recensione-itaobuy-spreadsheet",
    element: <Recensione />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-alternative",
    element: <Alternative />,
  },
  {
    path: "/articoli/qualita-prodotti-itaobuy",
    element: <Qualita />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-moda-uomo",
    element: <ModaUomo />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-moda-donna",
    element: <ModaDonna />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-guida-shopping",
    element: <GuidaShopping />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;